import * as React from "react";
import { StyleSheet, View } from "react-native";
import IconIonicons from "react-native-vector-icons/Ionicons";
import { blackColor } from "../../common/colors";

const StarRates = () => {

    return (
        <View style={styles.rateApp}>
            <IconIonicons
                style={styles.starDesign}
                name="md-star-outline"
                size={30}
                color={blackColor}
            ></IconIonicons>
            <IconIonicons
                style={styles.starDesign}
                name="md-star-outline"
                size={30}
                color={blackColor}
            ></IconIonicons>
            <IconIonicons
                style={styles.starDesign}
                name="md-star-outline"
                size={30}
                color={blackColor}
            ></IconIonicons>
            <IconIonicons
                style={styles.starDesign}
                name="md-star-outline"
                size={30}
                color={blackColor}
            ></IconIonicons>
            <IconIonicons
                name="md-star-outline"
                size={30}
                color={blackColor}
            ></IconIonicons>
        </View>
    );
};

export default (StarRates);

const styles = StyleSheet.create({
    rateApp: {
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'flex-start',
        marginBottom: 40,
    },
    starDesign: {
        marginRight: 20,
    }
});
